// 获取资金流水筛选信息
export const flowFiltering = ({ pay }) => pay.flowFiltering;
// 获取入金通道大分类
export const payType = ({ pay }) => pay.payType;
// 获取出金通道大分类
export const withdrawType = ({ pay }) => pay.withdrawType;
// 获取入金范围
export const fitlabelList = ({ pay }) => pay.fitlabelList;
